import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { AuthentificationService } from '../authentification.service';

@Component({
    selector: 'autologin',
    template: '',
    standalone: false
})
export class AutologinComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public subscriptionFacade: SubscriptionFacadeService,
    private authentificationService: AuthentificationService,
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      let token = params['token'] || '';
      if (token) {
        const userAccountId = params['userAccount'];
        const redirect = params['redirect'] || '/dashboard/global';
        this.authentificationService.autologin(token, userAccountId);
      } else {
        this.router.navigate([`/dashboard/global`]);
      }
    });
  }
}
